import React, { useState, useContext } from "react";
import DropdownButton from "./DropdownButton";
import { ModeContext } from "../context/ModeContext";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // State to manage mobile menu

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const { mode, changeMode } = useContext(ModeContext);

  return (
    <nav className="bg-accent1-default p-4 sticky top-0 left-0 w-full z-50 border-b-[6px] border-accent1-dark-default">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-6">
          {/* Logo */}
          <div className={`text-accent-theme-${mode} text-2xl font-bold`}>
            Justin Wang's Portfolio
          </div>

          {/* Links - Hidden on small screens */}
          <div className="hidden md:flex space-x-6">
            <a href="#home" className="text-white hover:text-gray-300">
              Home
            </a>
            <a href="#experience" className="text-white hover:text-gray-300">
              Experience
            </a>
            <a href="#skills" className="text-white hover:text-gray-300">
              Skills
            </a>
            <a href="#projects" className="text-white hover:text-gray-300">
              Projects
            </a>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="text-white focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={!isOpen ? "M4 6h16M4 12h16M4 18h16" : "M6 18L18 6M6 6l12 12"}
              ></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu - Shown on small screens when menu is open */}
      {isOpen && (
        <div className="md:hidden bg-accent1-default">
          <a href="#home" className="block text-white py-2 px-4">
            Home
          </a>
          <a href="#experience" className="block text-white py-2 px-4">
            Experience
          </a>
          <a href="#skills" className="block text-white py-2 px-4">
            Skills
          </a>
          <a href="#projects" className="block text-white py-2 px-4">
            Projects
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
